import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=18991524&"
import script from "./GalleryItem.vue?vue&type=script&lang=coffee&"
export * from "./GalleryItem.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports